export const menuItems = [
    "Home",
    "About",
    "Gallery",
    "Schedule",
    "Blog",
    "Pricing",
    "Classes",
    "Contact",
  ];